import React, { Component } from 'react'


class HomePageProgam extends Component {
  render() {
    return (
      <div>Home page progamm</div>
    )
  }
}

export default HomePageProgam